import React, { useContext } from "react";
import { Box, IconButton, useTheme, Typography } from "@mui/material";
import { ColorModeContext } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import EditIcon from "@mui/icons-material/Edit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useSelector } from "react-redux";

const Profile = ({ user }) => {
  return (
    <Box display="flex" alignItems="center" p={2}>
      <IconButton color="primary" aria-label="Edit Profile">
        <EditIcon />
      </IconButton>
      <h4>userId: {user?.id} </h4>
      {/* profile logic */}
      <img
        src={user?.profile_pic_url}
        alt="User Profile"
        style={{
          width: "48px",
          height: "48px",
          borderRadius: "50%",
          marginLeft: "1rem",
        }}
      />
    </Box>
  );
};

const Notifications = () => {
  return (
    <Box display="flex" alignItems="center" p={2}>
      <IconButton color="default" aria-label="View All Notifications">
        <NotificationsIcon />
      </IconButton>
      <h4>Notifications</h4>
      {/* notifications logic*/}
    </Box>
  );
};

const Topbar = () => {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const loggeinUser = useSelector((state) => state.user.buyer);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      {/* ICONS */}
      <IconButton onClick={colorMode.toggleColorMode}>
        {theme.palette.mode === "dark" ? (
          <DarkModeOutlinedIcon />
        ) : (
          <LightModeOutlinedIcon />
        )}
      </IconButton>

      <box className="flex me-auto">
        <Typography
                variant="h3"
                sx={{ m: "15px 0 5px 20px" }}
              >
                SALAMA PAY
        </Typography>
      </box>



      {isLoggedIn && (
        <Box className="flex ms-auto">
          <Notifications />

          <Profile user={loggeinUser} />
        </Box>
      )}
    </Box>
  );
};

export default Topbar;
